export function TargetEducation({period, title, org, note}){
  return(
    <article className="target-education">
      <p className="education-period">{period}</p>
      <h4 className="education-title">{title}</h4>
      <p className="education-org">{org}</p>
      {note && <span className="education-note">{note}</span>}
    </article>
  );
}
